export interface AttendanceRemoteList {
  date: string;
  attendances: AttendanceRemoteItem[];
}

export interface AttendanceRemoteItem {
  id: string;
  eventUri: string;
  name: string;
  squadUserId: string;
  squadUserName: string;
  customerId: string;
  customerName: string;
  attendanceUrl?: string;
  reason: string;
  status: string;
  startDate: string;
  endDate: string;
  hasParticipants: boolean;
  isRoomReady: boolean;
  reschedulingLink?: string;
  serviceType: string;
  serviceName: string;
  companyCnpj: string;
  companyId: string;
  companyName: string;
  eventType: string;
  reschedulingDate: string;
  reschedulingReason: string;
  roleId: string;
  roleName: string;
  squadUserImage: string;
  stratification: string[] | string;

  //frontend control
  showTimer?: boolean;
  isInAttendanceTime?: boolean;
  isExpired?: boolean;

  startDateFormatted?: string;
  endDateFormatted?: string;
  interval?;
  isExpand?: boolean;
  statusRoom?: {
    statusRoomLabel?: string;
    statusRoomColor?: string;
  };
  isExpiredEndDate?: boolean;
}

export interface AttendanceRemoteCanceled {
  canceledBy: string;
  cancelReason: string;
}

export interface AttendanceRemoteLog {
  userId: string;
  userType: UserType;
  action: AttendanceLogActions;
  scheduleAttendanceId: string;
}

export interface AttendanceRemoteLogResponse {
  actionObs: string;
  createdAt: string;
  user: string;
  serviceType: string;
  action: string;
  customer: string;
  company: string;
  starDate: Date | string;

  creationDate: string;
  description: string;
  logTypeEnum: string;
  referenceId: string;
}

// Movido para @recriar/mihmo-interfaces: a lib referencia este enum em
// user.model.ts, e lib importando do app criava dependência circular.
// Re-exportado aqui para não quebrar os imports existentes.
export { AttendanceRemoteStatus } from '@recriar/mihmo-interfaces';

export enum AttendanceRemoteActions {
  FinishAttendance = 'finishAttendance',
  NoShow = 'noShow',
}

export enum UserType {
  customer = 'customer',
  squadUser = 'squadUser',
}
export enum AttendanceLogActions {
  joinedRoom = 'entrou_na_sala',
  finalizedAttendance = 'finalizou_atendimento',
  cancelledAttendance = 'cancelou_atendimento',
  noShow = 'no_show',
  initiatedCall = 'iniciou_chamada',
  closedCall = 'encerrou_chamada',
  joinedWaitingRoom = 'entrou_sala_espera',
  scheduledAttendance = 'agendou_atendimento',
}

export const AttendanceLogActionLabel = {
  [AttendanceLogActions.joinedRoom]: 'Entrou na sala',
  [AttendanceLogActions.finalizedAttendance]: 'Finalizou atendimento',
  [AttendanceLogActions.cancelledAttendance]: 'Cancelou atendimento',
  [AttendanceLogActions.noShow]: 'No show',
  [AttendanceLogActions.initiatedCall]: 'Iniciou chamada',
  [AttendanceLogActions.closedCall]: 'Encerrou chamada',
  [AttendanceLogActions.joinedWaitingRoom]: 'Entrou na sala de espera',
  [AttendanceLogActions.scheduledAttendance]: 'Agendou atendimento',
};
